import React from "react";

const PLAN_COLORS = {
  Enterprise: ["#1E3A5F", "#D6EAF8"],
  enterprise: ["#1E3A5F", "#D6EAF8"],
  Business: ["#2E86AB", "#EBF5FB"],
  business: ["#2E86AB", "#EBF5FB"],
  Growth: ["#17A589", "#D5F5E3"],
  growth: ["#17A589", "#D5F5E3"],
  Starter: ["#5D6D7E", "#F2F3F4"],
  starter: ["#5D6D7E", "#F2F3F4"],
};

function PlanBadge({ plan }) {
  const [text, bg] = PLAN_COLORS[plan] || ["#5D6D7E", "#F2F3F4"];
  const label = (plan || "").charAt(0).toUpperCase() + (plan || "").slice(1);

  return (
    <span
      style={{
        background: bg,
        color: text,
        padding: "2px 9px",
        borderRadius: 20,
        fontSize: 11,
        fontWeight: 700,
      }}
    >
      {label}
    </span>
  );
}

export default PlanBadge;
